import React, { useState } from 'react';
import api from '../services/api';

// Pagamento de uma fatura (transferencia, marcado a mao pelo Manolo) - Neurotech-X 24/10/2026
// Mesmo botao para Synapse/Marketing (tipo "servico") e Telefonia (tipo "telefonia").
const hojeSP = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });
const br = (iso) => (iso ? iso.split('-').reverse().join('/') : '');

export default function PagamentoFatura({ tipo, fatura, onMudou }) {
    const [modo, setModo] = useState(null); // null | 'marcar' | 'desmarcar'
    const [data, setData] = useState(hojeSP());
    const [salvando, setSalvando] = useState(false);
    const [erro, setErro] = useState('');
    if (!fatura) return null;
    const msgErro = (e) => (e && e.response && e.response.data && e.response.data.error) || (e && e.message) || 'erro desconhecido';
    const hoje = hojeSP();
    const venc = fatura.vencimento_iso || null;
    const vencida = !fatura.pago_em && venc && venc < hoje;
    const quem = fatura.pago_marcado_por ? ('Marcado por ' + fatura.pago_marcado_por + (fatura.pago_marcado_em ? ' em ' + new Date(fatura.pago_marcado_em).toLocaleString('pt-BR') : '')) : '';
    const fechar = () => { setModo(null); setErro(''); };
    const abrirMarcar = () => { setData(hojeSP()); setErro(''); setModo('marcar'); };
    const salvar = async () => {
        setSalvando(true); setErro('');
        try {
            // manda o que a tela estava mostrando: se a fatura mudou nesse meio tempo, o Synapse recusa em vez de sobrescrever
            const esperado = fatura.pago_em || null;
            if (modo === 'marcar') await api.post('/api/servicos/fatura-pagamento/' + tipo + '/' + fatura.id, { pago_em: data, esperado });
            else await api.post('/api/servicos/fatura-pagamento/' + tipo + '/' + fatura.id + '/desmarcar', { esperado });
            setModo(null);
            if (onMudou) await onMudou();
        } catch (e) { setErro('Não salvou: ' + msgErro(e)); if (e && e.response && e.response.status === 409 && onMudou) await onMudou(); }
        setSalvando(false);
    };
    const btn = { padding: '6px 12px' };
    return (
        <span style={{ display: 'inline-flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            {fatura.pago_em
                ? (<span title={quem} style={{ fontSize: 12, fontWeight: 700, color: '#1e8449' }}>✓ Paga em {br(fatura.pago_em)}</span>)
                : (<span style={{ fontSize: 12, fontWeight: 700, color: vencida ? '#c0392b' : '#e67e22' }}>{vencida ? 'Vencida em ' + br(venc) + ' · em aberto' : (venc ? 'Em aberto · vence ' + br(venc) : 'Em aberto · sem vencimento')}</span>)}
            {modo === null && (fatura.pago_em
                ? <button type="button" className="btn-ghost" style={btn} onClick={() => { setErro(''); setModo('desmarcar'); }}>Desmarcar pagamento</button>
                : <button type="button" className="btn-ghost" style={Object.assign({}, btn, { borderColor: '#1e8449', color: '#1e8449' })} onClick={abrirMarcar}>Marcar como paga</button>)}
            {modo === 'marcar' && (<React.Fragment>
                <span style={{ fontSize: 12 }}>Pago em</span>
                <input type="date" value={data} max={hoje} onChange={e => setData(e.target.value)} disabled={salvando} />
                <button type="button" className="btn-ghost" style={Object.assign({}, btn, { borderColor: '#1e8449', color: '#1e8449' })} disabled={salvando || !data} onClick={salvar}>{salvando ? 'Salvando…' : 'Confirmar pagamento'}</button>
                <button type="button" className="btn-ghost" style={btn} disabled={salvando} onClick={fechar}>Cancelar</button>
            </React.Fragment>)}
            {modo === 'desmarcar' && (<React.Fragment>
                <span style={{ fontSize: 12 }}>A fatura volta a ficar em aberto.</span>
                <button type="button" className="btn-ghost" style={Object.assign({}, btn, { borderColor: '#c0392b', color: '#c0392b' })} disabled={salvando} onClick={salvar}>{salvando ? 'Salvando…' : 'Confirmar: desmarcar'}</button>
                <button type="button" className="btn-ghost" style={btn} disabled={salvando} onClick={fechar}>Cancelar</button>
            </React.Fragment>)}
            {erro && <span style={{ color: '#c0392b', fontSize: 12 }}>{erro}</span>}
        </span>
    );
}
